/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusDropdownMiniDto } from '../../models/lexplus-dropdown-mini-dto';

export interface ObjekteControllerGetKategorieDropdownOptionsV1$Params {
}

export function objekteControllerGetKategorieDropdownOptionsV1(http: HttpClient, rootUrl: string, params?: ObjekteControllerGetKategorieDropdownOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusDropdownMiniDto>>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerGetKategorieDropdownOptionsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusDropdownMiniDto>>;
    })
  );
}

objekteControllerGetKategorieDropdownOptionsV1.PATH = '/v1/objekte/kategorien';
